<div class="password-strength">
    <ng-container *ngIf="!showOnlyPasswordFormat">
      <div class="password-strength__levelMessage">
        {{ strengthMessage }}
      </div>
  
      <ul class="password-strength__bar">
        <li class="password-strength__level" [ngClass]="strengthBarColorClass?.bar0"></li>
        <li class="password-strength__level" [ngClass]="strengthBarColorClass?.bar1"></li>
        <li class="password-strength__level" [ngClass]="strengthBarColorClass?.bar2"></li>
        <li class="password-strength__level" [ngClass]="strengthBarColorClass?.bar3"></li>
      </ul>
    </ng-container>
  
    <div class="password-strength__format">
      <div class="password-strength-format__item">
        <span
          class="password-strength-format-item__icon"
          [ngClass]="
            passwordToCheck?.length >= 8
              ? 'password-strength-format-item__icon--checked'
              : 'password-strength-format-item__icon--dot'
          "
        ></span>
        {{ referenceDataLabels.PasswordStrengthMinCharacters | localizeLabel }}
      </div>
  
      <div class="password-strength-format__item">
        <span
          class="password-strength-format-item__icon"
          [ngClass]="
            lowerLettersFlag && upperLettersFlag
              ? 'password-strength-format-item__icon--checked'
              : 'password-strength-format-item__icon--dot'
          "
        ></span>
        {{ referenceDataLabels.PasswordStrengthUpperLowerCaseLetters | localizeLabel }}
      </div>
  
      <div *ngIf="symbolsAllowed" class="password-strength-format__item">
        <span
          class="password-strength-format-item__icon"
          [ngClass]="
            symbolsFlag ? 'password-strength-format-item__icon--checked' : 'password-strength-format-item__icon--dot'
          "
        ></span>
        {{ referenceDataLabels.PasswordStrengthSpecialCharacter | localizeLabel }}
      </div>
    </div>
  </div>